import { ComponentProps, useEffect, useRef } from 'react';

export function OrderWaiter({
  playAnimation,
  ...props
}: ComponentProps<'svg'> & { playAnimation: boolean }) {
  const ref = useRef<SVGSVGElement>(null);
  useEffect(() => {
    if (!playAnimation) {
      return;
    }
    const interval = setInterval(() => {
      const animatedElements =
        ref.current?.querySelectorAll('.animated-element') ?? [];
      animatedElements.forEach((element) => {
        element.getAnimations().forEach((animation) => {
          animation.cancel();
          animation.play();
        });
      });
    }, 6000);
    return () => clearInterval(interval);
  }, [playAnimation]);

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={217}
      height={120}
      fill="none"
      shapeRendering="optimizeQuality"
      style={{ overflow: 'visible' }}
      {...props}
    >
      <style>{css}</style>
      <path
        fill="#000"
        stroke="#fff"
        strokeWidth={0.606}
        d="M187.601 39.028h6.479a1.514 1.514 0 0 0 0-3.028h-7.571a1.51 1.51 0 0 0-1.437 1.036L175.5 68.528l3 .5 9.101-30Z"
        className="animated-element straw"
      />
      <path
        stroke="#AF272F"
        strokeLinecap="round"
        strokeWidth={3.028}
        d="M33.796 38.852c12.59 20.23 31.039 1.515 30.282 0"
      />
      <circle
        cx={48.937}
        cy={31.282}
        r={28.768}
        stroke="#000"
        strokeWidth={3.028}
      />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeWidth={3.028}
        d="m2 117.585 5.698-28.49a3.028 3.028 0 0 1 2.11-2.31l16.961-5.026c1.065-.316 2.214-.027 3.059.693 2.897 2.47 10.174 7.88 18.352 7.88 8.146 0 15.398-5.368 18.318-7.851.864-.735 2.043-1.017 3.123-.671l15.918 5.094a3.029 3.029 0 0 1 1.813 1.584l11.498 24.206c1.016 2.139 3.983 2.337 5.274.351l15.437-23.75c.76-1.17 2.215-1.644 3.565-1.293 4.007 1.044 6.84.64 11.357-.699"
      />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeWidth={1.544}
        d="M20.018 103.958h12.264c.753 0 1.363.61 1.363 1.363v8.538c0 .595-.387 1.122-.955 1.3l-5.615 1.761a1.353 1.353 0 0 1-.764.015l-6.65-1.803a1.363 1.363 0 0 1-1.006-1.315V105.321c0-.753.61-1.363 1.363-1.363Z"
      />
      <path
        stroke="#000"
        strokeLinecap="square"
        strokeWidth={1.999}
        d="M19.564 105.41H33.19"
      />
      <path
        fill="#000"
        stroke="#000"
        strokeWidth={1}
        d="M216.563 73.804c.083.07.141.133.179.19h-6.691V76c-2.855-.459-6.499-.875-10.775-1.238-10.966-.93-26.113-1.505-42.84-1.505-16.727 0-31.873.575-42.84 1.505-4.275.363-7.918.78-10.773 1.238v-2.004H96.13a.915.915 0 0 1 .179-.19c.185-.156.473-.317.868-.481.79-.327 1.965-.647 3.494-.953 3.054-.613 7.48-1.166 12.957-1.63 10.953-.93 26.088-1.504 42.808-1.504s31.855.575 42.808 1.504c5.477.464 9.903 1.017 12.957 1.63 1.529.306 2.704.626 3.494.953.395.164.683.325.868.48Zm-17.319 1.337c4.296.364 7.945.783 10.793 1.242-2.848.46-6.497.878-10.793 1.243-10.953.928-26.088 1.503-42.808 1.503s-31.855-.575-42.808-1.504c-4.296-.364-7.945-.783-10.793-1.242 2.848-.459 6.497-.878 10.793-1.242 10.953-.929 26.088-1.504 42.808-1.504s31.855.575 42.808 1.504Zm-96.803.92a64.62 64.62 0 0 0-.747.128 50.548 50.548 0 0 1-1.023-.193c-1.529-.307-2.704-.627-3.494-.954-.395-.164-.683-.325-.868-.48a.926.926 0 0 1-.175-.186h6.307v1.685Zm-6.376 1.85v-3.056c.228.19.556.37.966.54.824.341 2.029.667 3.565.975l.068.013-.068.014c-1.536.308-2.74.633-3.565.975-.41.17-.738.35-.966.54Zm.063.487a.907.907 0 0 1 .181-.193c.185-.155.473-.317.868-.48.79-.328 1.965-.648 3.494-.954.325-.065.667-.13 1.023-.194.242.043.491.086.747.129v1.692h-6.313Zm114.305-4.022h6.305a.912.912 0 0 1-.175.186c-.185.155-.473.316-.868.48-.79.327-1.965.647-3.494.954-.325.065-.667.13-1.023.193a65.87 65.87 0 0 0-.745-.128v-1.685Zm-11.157 3.63c4.276-.363 7.92-.78 10.775-1.239v2.012h6.685a.938.938 0 0 1-.173.183c-.185.155-.473.316-.868.48-.79.328-1.965.647-3.494.954-3.054.612-7.48 1.165-12.957 1.63-10.953.929-26.088 1.504-42.808 1.504s-31.855-.575-42.808-1.504c-5.477-.465-9.903-1.017-12.957-1.63-1.529-.307-2.704-.626-3.494-.954-.395-.163-.683-.325-.868-.48a.935.935 0 0 1-.173-.182h6.687v-2.012c2.855.458 6.498.875 10.773 1.238 10.967.93 26.113 1.505 42.84 1.505 16.727 0 31.874-.575 42.84-1.505Zm11.157-1.3c.255-.043.503-.086.745-.129.356.064.698.129 1.023.194 1.529.306 2.704.626 3.494.953.395.164.683.326.868.48.085.071.143.136.181.194h-6.311v-1.693Zm6.375-1.851.001-.002v3.06l-.001-.001c-.228-.19-.556-.37-.967-.54-.824-.342-2.029-.667-3.565-.975l-.067-.014.067-.013c1.536-.308 2.741-.634 3.565-.975.411-.17.739-.35.967-.54Z"
      />
      <g className="animated-element bun-top" clipPath="url(#clip0_1940_16883)">
        <path
          fill="#000"
          stroke="#fff"
          strokeWidth={0.61}
          d="M121.877 47.514c-3.078 0-5.572-2.462-5.572-5.479 0-4.082 2.44-7.756 6.514-10.424 4.073-2.667 9.754-4.306 16.144-4.306 6.39 0 12.071 1.639 16.144 4.306 4.074 2.668 6.514 6.342 6.514 10.424 0 3.017-2.494 5.479-5.572 5.479h-34.172Zm36.19-5.479c0-3.104-2.262-5.903-5.73-7.909-3.479-2.012-8.233-3.267-13.374-3.267s-9.895 1.255-13.374 3.267c-3.467 2.006-5.73 4.805-5.73 7.91 0 1.077.921 1.924 2.018 1.924h34.172c1.097 0 2.018-.847 2.018-1.925Zm-17.91-5.43a1.776 1.776 0 0 1-3.033-1.257c0-.983.796-1.787 1.777-1.787.984 0 1.776.788 1.776 1.767v.02c0 .472-.187.924-.52 1.257Zm-10.409 2.06a1.777 1.777 0 0 1-3.034-1.256c0-.983.797-1.787 1.777-1.787.985 0 1.777.788 1.777 1.767v.02c0 .472-.187.924-.52 1.257Zm20.818 0a1.776 1.776 0 0 1-3.033-1.256c0-.983.796-1.787 1.777-1.787.985 0 1.777.788 1.777 1.767v.02c0 .472-.187.924-.521 1.257Z"
        />
      </g>
      <g className="animated-element patty" clipPath="url(#clip1_1940_16883)">
        <path
          fill="#AF272F"
          d="M159.719 54.064c-1.867 0-2.675-.647-3.897-1.624-1.414-1.132-3.171-2.54-6.502-2.54s-5.092 1.408-6.506 2.538c-1.222.979-2.031 1.626-3.901 1.626-1.874 0-2.729-.683-3.91-1.626-1.413-1.13-3.175-2.538-6.506-2.538-3.335 0-5.094 1.408-6.51 2.538-1.224.979-2.034 1.626-3.905 1.626a2.081 2.081 0 1 0 0 4.164c3.333 0 5.092-1.407 6.506-2.538 1.18-.943 2.034-1.626 3.909-1.626 1.872 0 2.682.648 3.906 1.626 1.414 1.13 3.175 2.538 6.51 2.538 3.333 0 5.09-1.407 6.504-2.538 1.222-.978 2.03-1.626 3.903-1.626 1.87 0 2.678.648 3.9 1.626 1.411 1.13 3.168 2.538 6.499 2.538a2.081 2.081 0 1 0 0-4.164Z"
        />
        <path
          stroke="#fff"
          strokeWidth={0.606}
          d="m155.633 52.677.021.016c.596.477 1.126.9 1.743 1.198.635.306 1.35.476 2.322.476a1.778 1.778 0 1 1 0 3.558c-3.223 0-4.911-1.35-6.31-2.471l-.018-.014c-.598-.48-1.128-.904-1.747-1.203-.635-.306-1.35-.476-2.324-.476-.975 0-1.692.17-2.327.476-.62.3-1.15.724-1.748 1.203l-.017.014h-.002c-1.401 1.121-3.089 2.471-6.313 2.471-3.227 0-4.919-1.35-6.321-2.471l-.016-.014c-.6-.479-1.131-.904-1.751-1.203-.637-.306-1.353-.476-2.328-.476-.978 0-1.706.18-2.347.49-.626.303-1.156.727-1.735 1.19l-.016.012c-1.402 1.121-3.092 2.472-6.317 2.472a1.78 1.78 0 0 1 0-3.558c.975 0 1.691-.17 2.327-.476.62-.3 1.152-.724 1.751-1.203l.016-.013h.001l.001-.002c1.404-1.12 3.094-2.47 6.319-2.47 3.224 0 4.916 1.35 6.317 2.472l.013.01c.58.463 1.112.889 1.739 1.192.641.31 1.369.49 2.347.49.974 0 1.69-.17 2.325-.476.621-.3 1.152-.725 1.752-1.205l.014-.011c1.401-1.121 3.093-2.472 6.316-2.472s4.911 1.35 6.313 2.474Z"
        />
      </g>
      <g
        className="animated-element bun-bottom"
        clipPath="url(#clip2_1940_16883)"
      >
        <path
          fill="#000"
          d="M157.637 60h-37.473A4.168 4.168 0 0 0 116 64.164c0 4.592 3.735 8.327 8.327 8.327h29.147c4.592 0 8.327-3.735 8.327-8.327A4.169 4.169 0 0 0 157.637 60Zm-4.163 8.328h-29.147a4.168 4.168 0 0 1-4.163-4.164h37.473a4.169 4.169 0 0 1-4.163 4.163Z"
        />
        <path
          stroke="#fff"
          strokeWidth={0.606}
          d="M120.164 63.86h-.303v.304a4.47 4.47 0 0 0 4.466 4.466h29.147a4.472 4.472 0 0 0 4.466-4.466v-.303H120.164Zm0-3.557h37.473a3.867 3.867 0 0 1 3.861 3.86c0 4.426-3.599 8.025-8.024 8.025h-29.147c-4.425 0-8.024-3.599-8.024-8.024a3.865 3.865 0 0 1 3.861-3.861Z"
        />
      </g>
      <g className="animated-element cup">
        <path
          fill="#000"
          fillRule="evenodd"
          d="M197.268 45H170.014a1.516 1.516 0 0 0-1.071 2.585c.284.284.67.443 1.071.443h.177l2.863 22.9a1.514 1.514 0 0 0 1.502 1.326h18.169a1.514 1.514 0 0 0 1.502-1.327l2.864-22.899h.177a1.514 1.514 0 0 0 0-3.028Zm-21.375 24.225h15.495l.595-4.752c-3.651-.54-7.111-2.158-10.089-4.735a4.849 4.849 0 0 0-.218-.175l-.056-.044-.238-.188-.003-.002c-2.177-1.756-4.624-2.928-7.156-3.465l1.67 13.361Zm7.984-11.775c2.516 2.176 5.425 3.546 8.482 4.014l1.681-13.436h-20.796l.586 4.686c3.362.514 6.612 1.969 9.451 4.258l.001.003h.002l.189.148c.136.106.272.212.404.327Z"
          clipRule="evenodd"
        />
        <path
          fill="#fff"
          d="M192.359 61.464c-3.057-.468-5.966-1.838-8.482-4.014-.132-.115-.268-.22-.404-.327l-.189-.148h-.002l-.001-.003c-2.839-2.29-6.089-3.745-9.451-4.258l-.586-4.686h20.796l-1.681 13.436ZM191.388 69.225h-15.495l-1.67-13.361c2.532.537 4.979 1.709 7.156 3.465l.003.002.238.188.056.044c.073.056.146.113.218.175 2.978 2.577 6.438 4.194 10.089 4.735l-.595 4.752Z"
        />
        <path
          stroke="#fff"
          strokeWidth={0.606}
          d="m181.62 59.519-.238-.188-.003-.002c-2.177-1.756-4.624-2.928-7.156-3.465l1.67 13.361h15.495l.595-4.752c-3.651-.54-7.111-2.158-10.089-4.735a4.849 4.849 0 0 0-.218-.175m-.056-.044.056.044m-.056-.044.056.044M197.268 45H170.014a1.516 1.516 0 0 0-1.071 2.585c.284.284.67.443 1.071.443h.177l2.863 22.9a1.514 1.514 0 0 0 1.502 1.326h18.169a1.514 1.514 0 0 0 1.502-1.327l2.864-22.899h.177a1.514 1.514 0 0 0 0-3.028Zm-4.909 16.464c-3.057-.468-5.966-1.838-8.482-4.014-.132-.115-.268-.22-.404-.327l-.189-.148h-.002l-.001-.003c-2.839-2.29-6.089-3.745-9.451-4.258l-.586-4.686h20.796l-1.681 13.436Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_1940_16883">
          <path fill="#fff" d="M116 27h45.93v20.85H116z" />
        </clipPath>
        <clipPath id="clip1_1940_16883">
          <path fill="#fff" d="M116 50h45.93v12.49H116z" />
        </clipPath>
        <clipPath id="clip2_1940_16883">
          <path fill="#fff" d="M116 60h45.93v12.49H116z" />
        </clipPath>
      </defs>
    </svg>
  );
}

const css = `
    :root {
      --stagger: 500ms;
    }
    @keyframes assemble {
      from {
        transform: translateY(-50%);
        opacity: 0;
      }
      50% {
        opacity: 1;
      }
      100% {
        transform: translateY(0px);
      }
    }
    .animated-element {
      will-change: transform;
      animation: assemble 1.5s ease both;
    }

    .bun-bottom{
      animation-delay: calc(var(--stagger) * 1);
    }
    .patty {
      animation-delay: calc(var(--stagger) * 2);
    }
    .bun-top {
      animation-delay: calc(var(--stagger) * 3);
    }
    .cup {
      animation-delay: calc(var(--stagger) * 4);
    }
    .straw {
      animation-delay: calc(var(--stagger) * 5);
    }
`;
